import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 登録可能マークファイル一覧取得サービス
 *
 * @export GetMarkFileListService
 * @class GetMarkFileListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetMarkFileListService extends PlessJsonResponderSub<any> {

  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetMarkFileListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest();
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetMarkFileListService
   */
  execute(successFunc: Function = null): void {
    this.successFunc = successFunc;
    this.send('getMarkFileList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetMarkFileListService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
